import { useMemo, useState } from 'react'
import EstoqueHttp from '../../../../../services/api/https/estoque/Estoque.http'
import { errorHandler } from '../../../../../services/util/error.service'
import { getPeriodoMesAtual, parseToMysqlFormat } from '../../../../../services/util/date.service'

function getCurrentTimeString() {
  const now = new Date()
  return `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`
}

export const MENU_ITEMS = ['1. Editar', '2. Produtos']

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  CYCLES: 'Carregando Ciclos de Entrega',
  PICKINGS: 'Carregando Pickings',
  PALLETAREAS: 'Carregando Pallets Area',
  PRODUTOS: 'Carregando Produtos',
  POSICOES: 'Carregando posições do estoque',
  POSICOES_ORIGEM: 'Carregando posições do estoque origem',
  MOVING: 'Concluindo operação',
}

export const VISUALIZER_TYPE = [
  { id: 0, name: 'Por Pallet' },
  { id: 1, name: 'Por Produto' },
]

const INITIAL_STATE = {
  movimentacoes: [],
  modal: {
    show: false,
    data: null,
  },
  dataMovimentacao: new Date(),
  horaMovimentacao: '',
  pallets: [],
  posicoesOrigem: [],
  produtos: [],
  periodo: getPeriodoMesAtual(),
  posicoes: [],
  originalPosicoes: [],
  originalPallets: [],
  operacoes: [],
  selectedOperacao: null,
  selectedEstoqueOrigem: null,
  selectedEstoque: {},
  selectedPallets: [],
  selectedProdutos: [],
  selectedPosicao: null,
  selectedPosicaoOrigem: null,
  selectedVisualizer: null,
  globalFilter: '',
  searchPallet: '',
  searchPosicao: '',
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

export default function useMovimentacaoEstoque() {
  const [state, setState] = useState(() => ({ ...INITIAL_STATE, horaMovimentacao: getCurrentTimeString() }))

  const localDispatch = useMemo(() => {
    //Helpers

    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
          pathToRedirect: null,
        }))
      },

      getOperacoesEstoqueTransferencia(selectedTp) {
        EstoqueHttp.getOperacoesEstoqueTransferencia(selectedTp)
          .then(res =>
            setState(prevState => ({
              ...prevState,
              operacoes: res,
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      getPosicoesEstoque(selectedTp, estoqueId) {
        EstoqueHttp.getPosicoesEstoques(selectedTp, estoqueId)
          .then(res =>
            setState(prevState => ({
              ...prevState,
              posicoes: res,
              originalPosicoes: res,
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      getPosicoesEstoqueOrigem(selectedTp, estoqueId) {
        EstoqueHttp.getPosicoesEstoques(selectedTp, estoqueId)
          .then(res =>
            setState(prevState => ({
              ...prevState,
              posicoesOrigem: res.map(pos => ({ id: pos.id, name: pos.endereco })),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      getPalletAreas(selectedTp, posicaoEstoqueId) {
        EstoqueHttp.getPalletsOnPosicaoEstoque(selectedTp, posicaoEstoqueId)
          .then(res =>
            setState(prevState => ({
              ...prevState,
              pallets: res.map(p => ({ ...p, selected: false, alocated: false })),
              originalPallets: res.map(p => ({ ...p, selected: false, alocated: false })),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      getProdutos(selectedTp, posicaoEstoqueId) {
        EstoqueHttp.getProdutosOnPosicaoEstoque(selectedTp, posicaoEstoqueId)
          .then(res =>
            setState(prevState => ({
              ...prevState,
              produtos: res.map(p => ({ ...p, alocated: false, qte_alocar: 0 })),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      postMovimentacaoEstoqueTransferencia(
        movimentacaoEstoque,
        movimentacaoEstoqueInfo,
        produtos,
        selectedTp,
        style,
        selectedOrigem,
      ) {
        EstoqueHttp.postMovimentacaoEstoqueTransferencia(
          {
            movimentacaoEstoque,
            movimentacaoEstoqueInfo,
            produtos,
            style,
            posicaoOrigemId: selectedOrigem.id,
          },
          selectedTp,
        )
          .then(res =>
            setState(prevState => ({
              ...prevState,
              pallets:
                style !== 'Produtos'
                  ? res.map(p => ({ ...p, selected: false, alocated: false }))
                  : [],
              produtos:
                style === 'Produtos'
                  ? res.map(p => ({ ...p, alocated: false, qte_alocar: 0 }))
                  : [],
              loadingMessage: LOAD_MESSAGE.POSICOES,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      //Events
      async onInit(selectedTp) {
        if (!selectedTp) {
          setState(prevState => ({ ...prevState, errorMessage: 'Selecione um TP' }))
        } else {
          await EstoqueHttp.getEstoques(selectedTp)
            .then(res => {
              setState(prevState => ({
                ...prevState,
                estoques: res,
                loadingMessage: LOAD_MESSAGE.NONE,
              }))
            })
            .catch(err =>
              setState(prevState => ({ ...prevState, errorMessage: errorHandler(err) })),
            )
          this.getOperacoesEstoqueTransferencia(selectedTp)
        }
      },

      onChange(name, value) {
        setState(prevState => {
          prevState[name] = value
          switch (name) {
            case 'selectedEstoque':
              prevState.loadingMessage = LOAD_MESSAGE.POSICOES
              break
            case 'selectedEstoqueOrigem':
              prevState.selectedPosicaoOrigem = null
              prevState.loadingMessage = LOAD_MESSAGE.POSICOES_ORIGEM
              break
            case 'selectedPosicaoOrigem':
              if (
                prevState.selectedVisualizer &&
                prevState.selectedVisualizer.name === 'Por Pallet'
              )
                prevState.loadingMessage = LOAD_MESSAGE.PALLETAREAS
              else if (
                prevState.selectedVisualizer &&
                prevState.selectedVisualizer.name === 'Por Produto'
              )
                prevState.loadingMessage = LOAD_MESSAGE.PRODUTOS
              break
            case 'selectedVisualizer':
              if (prevState.selectedPosicaoOrigem !== null) {
                if (value.name === 'Por Pallet') prevState.loadingMessage = LOAD_MESSAGE.PALLETAREAS
                else prevState.loadingMessage = LOAD_MESSAGE.PRODUTOS
              }
              break
            default:
              break
          }

          return { ...prevState }
        })
      },

      onChangeProduto(produtoId, value, name) {
        setState(prevState => {
          const index = prevState.produtos.findIndex(p => p.id === produtoId)
          if (index !== -1) {
            prevState.produtos[index][name] = value
          }
          return { ...prevState }
        })
      },

      onBtnPesquisarClick(dataInicial, dataFinal) {
        setState(prevState => ({
          ...prevState,
          periodo: { dataInicial, dataFinal },
          loadingMessage: LOAD_MESSAGE.PICKINGS,
        }))
      },

      onSearchPosicoesChange(value) {
        setState(prevState => {
          prevState.searchPosicao = value

          if (!prevState.originalPosicoes.length) return { ...prevState }

          if (!value.length) prevState.posicoes = prevState.originalPosicoes
          else {
            prevState.posicoes = prevState.originalPosicoes.filter(p =>
              p.endereco.toLowerCase().includes(value.toLowerCase()),
            )
          }

          return { ...prevState }
        })
      },

      onSearchPalletsChange(value) {
        setState(prevState => {
          prevState.searchPallet = value

          if (!prevState.originalPallets.length) return { ...prevState }

          if (!value.length) prevState.pallets = prevState.originalPallets
          else {
            prevState.pallets = prevState.originalPallets.filter(p =>
              p.pallet_area_id.toString().toLowerCase().includes(value.toLowerCase()),
            )
          }

          return { ...prevState }
        })
      },

      onClickPosicao(posicao) {
        setState(prevState => ({ ...prevState, selectedPosicao: posicao }))
      },

      onClickPallets(pallet) {
        setState(prevState => {
          const index = prevState.pallets.findIndex(p => p.id === pallet.id)
          prevState.pallets[index].selected = !prevState.pallets[index].selected

          return { ...prevState }
        })
      },

      onClickAlocar(pallets, produtos, selectedPosicao, selectedVisualizer, selectedOrigem) {
        setState(prevState => {
          if (selectedVisualizer !== 'Por Produto') {
            if (!pallets.length) return { ...prevState }

            prevState.pallets = pallets.map(p => {
              if (p.selected) {
                p.selected = false
                p.alocated = true
                p.posicao = selectedPosicao
              }
              return { ...p }
            })

            prevState.posicoes = prevState.posicoes.map(p => {
              p.pallets = prevState.pallets.filter(
                pal => pal.selected || (pal.alocated && pal.posicao.id === p.id),
              ).length

              return p
            })
          } else {
            if (!produtos.length) return { ...prevState }
            if (!selectedPosicao)
              return { ...prevState, errorMessage: 'Selecione uma posição para alocar' }

            const backupProdutos = [...prevState.produtos.map(p => ({ ...p }))]

            prevState.produtos.forEach(p => {
              prevState.selectedProdutos.forEach(sp => {
                if (sp.id === p.id) {
                  if (Number(p.qte_alocar) < 1 || Number(p.qte_alocar) > p.quantidade) {
                    prevState.errorMessage = `Insira uma quantidade valida para alocar no produto: ${p.name}`
                  } else {
                    p.pos_estoque = selectedPosicao.endereco
                    p.qte_alocated = p.qte_alocar
                    p.posicao = selectedPosicao
                    p.alocated = true
                  }
                }
              })
            })

            if (prevState.errorMessage) {
              prevState.selectedProdutos = []
              prevState.produtos = [...backupProdutos]
              return { ...prevState }
            }

            const indexTarget = prevState.posicoes.findIndex(p => p.id === selectedPosicao.id)
            if (indexTarget !== -1) {
              prevState.posicoes[indexTarget].caixas += prevState.selectedProdutos
                .filter(sp => sp.posicao.id === selectedPosicao.id)
                .reduce((curr, prev) => curr + Number(prev.qte_alocated), 0)
            }

            const indexOrigin = prevState.posicoes.findIndex(p => p.id === selectedOrigem.id)
            if (indexOrigin !== -1) {
              prevState.posicoes[indexOrigin].caixas -= prevState.selectedProdutos
                .filter(sp => sp.posicao.id === selectedPosicao.id)
                .reduce((curr, prev) => curr + Number(prev.qte_alocated), 0)
            }

            if (!prevState.errorMessage) prevState.selectedProdutos = []
          }

          return { ...prevState }
        })
      },

      validatDataValidade(validade) {
        if (validade.length < 10) return 'Insira uma data de validade'

        const validadeDatas = validade.split('/').map(Number)

        if (validadeDatas[0] < 1 || validadeDatas > 31) return 'Insira um dia valido'
        else if (validadeDatas[1] < 1 || validadeDatas[1] > 12) return 'Insira um mês valido'
        else if (validadeDatas[2] < 2018 || validadeDatas[2] > 2200) return 'Insira um ano valido'
        return null
      },

      onClickDesalocar(pallets, produtos, selectedVisualizer, selectedOrigem) {
        setState(prevState => {
          if (selectedVisualizer !== 'Por Produto') {
            if (!pallets.length) return { ...prevState }

            prevState.pallets = pallets.map(p => {
              if (p.selected) {
                const posIndex = prevState.posicoes.findIndex(pos => pos.id === p.posicao.id)

                prevState.posicoes[posIndex].pallets--

                p.selected = false
                p.alocated = false
                p.posicao = null
              }
              return { ...p }
            })
          } else {
            if (!produtos.length) return { ...prevState }

            const selectedPosicoesIds = prevState.produtos
              .filter(p => p.alocated)
              .map(p => p.posicao.id)

            prevState.posicoes.forEach(pos => {
              if (selectedPosicoesIds.includes(pos.id)) {
                const index = prevState.posicoes.findIndex(p => p.id === pos.id)

                if (index !== -1) {
                  const qteTotal = prevState.selectedProdutos
                    .filter(sp => sp.posicao.id === pos.id)
                    .map(sp => sp.qte_alocated)
                    .reduce((curr, prev) => curr + Number(prev), 0)
                  prevState.posicoes[index].caixas -= qteTotal

                  const indexOrigem = prevState.posicoes.findIndex(p => p.id === selectedOrigem.id)
                  prevState.posicoes[indexOrigem].caixas += qteTotal
                }
              }
            })

            prevState.produtos.forEach(p => {
              prevState.selectedProdutos.forEach(sp => {
                if (sp.id === p.id) {
                  p.pos_estoque = ''
                  p.qte_alocated = 0
                  p.posicao = null
                  p.alocated = false
                }
              })
            })

            prevState.selectedProdutos = []
          }
          return { ...prevState }
        })
      },

      async onClickConcluir(
        pallets,
        produtos,
        data,
        hora,
        operacao,
        selectedTp,
        selectedVisualizer,
        selectedOrigem,
      ) {
        if (!operacao) {
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Selecione uma operação antes de concluir.',
          }))
          return
        }

        setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.MOVING }))

        const movimentacaoEstoque = {
          operacao_estoque_id: operacao.id,
          data_movimentacao: `${parseToMysqlFormat(data)} ${hora || '00:00'}:00`,
          tp_id: selectedTp,
        }

        if (selectedVisualizer.name !== 'Por Produto') {
          const palletsAlocated = pallets.filter(p => p.alocated)
          if (!palletsAlocated.length) {
            setState(prevState => ({
              ...prevState,
              errorMessage: 'Você precisar alocar pelo menos um pallet para prosseguir.',
              loadingMessage: LOAD_MESSAGE.NONE,
            }))
            return
          }

          const movimentacoesEstoqueInfo = palletsAlocated.map(p => ({
            posicao_estoque_id: p.posicao.id,
            pallet_area_id: p.pallet_area_id,
            picking_id: p.picking_id,
            type: 'recebimento',
          }))

          await this.postMovimentacaoEstoqueTransferencia(
            movimentacaoEstoque,
            movimentacoesEstoqueInfo,
            produtos,
            selectedTp,
            'Pallet',
            selectedOrigem,
          )
        } else {
          const produtosAlocated = produtos.filter(p => p.alocated)
          if (!produtosAlocated.length) {
            setState(prevState => ({
              ...prevState,
              errorMessage: 'Você precisar alocar pelo menos um produto para prosseguir.',
              loadingMessage: LOAD_MESSAGE.NONE,
            }))
            return
          }

          const posicoesSelecionadasSet = new Set()

          produtosAlocated.forEach(p =>
            posicoesSelecionadasSet.add(
              JSON.stringify({ posicao_id: p.posicao.id, picking_id: p.picking_id }),
            ),
          )

          const posicoesSelecionadasUnique = Array.from(posicoesSelecionadasSet).map(JSON.parse)
          const movimentacoesEstoqueInfo = []

          posicoesSelecionadasUnique.forEach(pos => {
            movimentacoesEstoqueInfo.push({
              posicao_estoque_id: pos.posicao_id,
              picking_id: pos.picking_id,
              type: 'recebimento',
              items: produtosAlocated
                .filter(p => p.alocated && p.picking_id === pos.picking_id)
                .map(p => ({
                  product_id: p.product_id,
                  quantidade: Number(p.qte_alocar),
                  data_validade:
                    p.validade !== null && !p.validade.includes('_')
                      ? parseToMysqlFormat(p.validade)
                      : null,
                  lote: p.lote,
                })),
            })
          })

          const produtosToAlocate = produtos
            .filter(p => p.alocated)
            .map(p => ({
              ...p,
              validade:
                p.validade !== null && !p.validade.includes('_')
                  ? parseToMysqlFormat(p.validade)
                  : null,
              lote: p.lote !== null && p.lote.length ? p.lote : null,
              picking_id: p.picking_id,
            }))

          await this.postMovimentacaoEstoqueTransferencia(
            movimentacaoEstoque,
            movimentacoesEstoqueInfo,
            produtosToAlocate,
            selectedTp,
            'Produtos',
            selectedOrigem,
          )
        }
      },
    }
  }, [])

  return { state, localDispatch }
}
